// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Ne1i","ranges":"BmiRanges_ranges__1CRqM"};